




















































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchCamaraModulo } from '@/pantallas/Camaras/fetchCamaraModulos';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import ValidaRut from '@/config/validaRut';
import { Validator } from 'vee-validate';
import moment from 'moment';

@Component({
  components: {
    DateComponent: DatePicker,
    TimeComponent: TimePicker,
    FormFieldsContainer,
  },
})
export default class CrearVODForm extends Vue {
  // @Prop({ default: false }) openDialog!: boolean;
  @Prop({ default: ''}) patent: string;
  loadingService = new LoadingService();
  dialog: boolean = false;
  vr: ValidaRut = new ValidaRut();
  channelSelect: any[] = [];
  channelsDict: { [id_channel: string]: string[] } = {};
  isFormValid: boolean = true;
  $snotify: any;
  formFields: {
    patent: any;
    channel: any;
    dateStart: any;
    timeStart: any;
    dateEnd: any;
    timeEnd: any;
    emails: any;
  } = {
    patent: {
      label: 'Patente/Camara',
      value: '',
      items: [],
      patent: '',
    },
    channel: {
      label: 'Canales',
      value: '',
    },
    dateStart: {
      label: 'Fecha desde',
      value: '',
    },
    timeStart: {
      label: 'Hora desde',
      value: '',
    },
    dateEnd: {
      label: 'Fecha hasta',
      value: '',
    },
    timeEnd: {
      label: 'Hora hasta',
      value: '',
    },
    emails: {
      label: 'Envío correo',
      value: '',
    },
  };

  mounted() {
    this.getChannels();
    this.chargePatentsCamera();
    if(this.patent != ''){
      this.formFields.patent.value = this.patent;
    }
  }

  async getChannels() {
    this.loadingService.showLoading();
    var self = this;
    fetchCamaraModulo({}, 'getChannels')
      .then((response: any) => {
        this.channelsDict = response.data.data;
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  changeValuePatent(data: any) {
    this.formFields.patent.value = data.cod;
  }

  created() {
    var r = this.vr;

    Validator.extend('emailFormato', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Email/s inválido/s';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: r.validaEmails(value),
            data: r.validaEmails(value)
              ? undefined
              : {
                  message: '* Email/s inválido/s',
                },
          });
        });
      },
    });
  }

  getStateString(state: string): string {
    var stateString: string = '';
    if (state == 'Linea') {
      stateString = 'En Línea';
    } else if (state == 'Desconecta') {
      stateString = 'Desconectado';
    } else if (state == 'Sin Info') {
      stateString = 'Sin Información';
    }
    return stateString;
  }

  textoComprimido(item: any) {
    let retorno: string = '';
    if (item.length > 14) {
      retorno = item.substr(0, 13) + '...';
    } else {
      retorno = item;
    }
    return retorno;
  }

  getHtmlFromState(state: string): string {
    const style =
      'width: 24px; height: 24px;margin-top: 2%; border-radius: 50%; ';
    var html = '';
    var css = '';
    if (state == 'Linea') {
      css = style + ' background: rgb(42, 255, 78)';
    } else if (state == 'Desconecta') {
      css = style + ' background: rgb(255, 58, 58)';
    } else if (state == 'Sin Info') {
      css = style + ' background: rgb(33, 33, 255)';
    }
    return css;
  }

  async handleClick() {
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      const date_start = moment(this.formFields.dateStart.value.toString())
        .format('YYYY-MM-DD')
        .toString();
      const time_start =
        moment(this.formFields.timeStart.value.toString())
          .format('HH:mm')
          .toString() + ':00';
      const date_end = moment(this.formFields.dateEnd.value.toString())
        .format('YYYY-MM-DD')
        .toString();
      const time_end =
        moment(this.formFields.timeEnd.value.toString())
          .format('HH:mm')
          .toString() + ':00';

      const body = {
        //id_cliente: this.getClientID().toString(),
        id_cliente: this.getClientID(),
        id_camara: this.formFields.patent.value,
        channel: this.formFields.channel.value,
        fecha_inicio: date_start + ' ' + time_start,
        fecha_fin: date_end + ' ' + time_end,
        correos: this.formFields.emails.value
        //patente: this.patentFormat,
      };
      //CamaraEventBus.$emit('postVOD', body);
      this.postVOD(body);
    }
  }

  async postVOD(body: any) {
    this.loadingService.showLoading();
    //const body: {} = {id_cliente: this.getClientID()};
    var self = this;
    fetchCamaraModulo(body, 'postVOD')
      .then((response: any) => {
        console.log(response.data);
        if (response.data.CODIGO_RESPUESTA == '2') {
          if (response.data.hasOwnProperty('MENSAJE_RESPUESTA')) {
            this.$snotify.error(response.data.MENSAJE_RESPUESTA);
          } else {
            this.$snotify.error('Hubo un error al crear el VOD');
          }
        } else {
          if (response.data.id_solicitud != 'without_id') {
            this.$snotify.success('El VOD se ha creado con éxito');
            CamaraEventBus.$emit('postVOD', body);
          } else {
            this.$snotify.error('Hubo un error al crear el VOD');
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Hubo un error al crear el VOD');
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  clearFormfields() {
    this.formFields.patent.value = '';
    this.formFields.channel.value = '';
    this.formFields.dateStart.value = '';
    this.formFields.timeStart.value = '';
    this.formFields.dateEnd.value = '';
    this.formFields.timeEnd.value = '';
    this.$validator.reset();
  }

  changePatent() {
    this.formFields.channel.value = '';
    this.channelSelect = this.channelsDict[this.formFields.patent.value];
  }

  // changePatent() {
  //   this.formFields.channel.value = '';
  //   if (this.formFields.patent.value != '') {
  //     const camara = this.formFields.patent.value
  //       .toString()
  //       .split(' ')[1]
  //       .slice(1, -1);
  //       this.channelSelect = this.channelsDict[camara];
  //   }else{
  //     this.channelSelect = this.channelsDict[""];
  //   }
  // }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
  }

  getUserID(): number {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  }

  async chargePatentsCamera() {
    this.loadingService.showLoading();
    const body: {} = { id_cliente: this.getClientID(), id_usuario: this.getUserID() };
    var self = this;
    fetchCamaraModulo(body, 'getPatentCameras')
      .then((response: any) => {
        self.formFields.patent.items = response.data.data || [];
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  // @Watch('openDialog')
  // onDialogChanged(value: boolean, lastValue: boolean) {
  //   this.clearFormfields();
  //   this.dialog = value;
  // }

  closeDialog() {
    CamaraEventBus.$emit('closeDialog');
  }

  get cameraFormat(): string {
    return this.formFields.patent.value
      .toString()
      .split(' ')[1]
      .slice(1, -1);
  }
}
